<template>
  <div
    class="lead-communication-tabs"
    :class="{ 'lead-communication-tabs--new': design === 'new' }"
    role="tablist"
    aria-label="Communication view"
  >
    <button
      v-for="tab in tabs"
      :key="tab.code"
      type="button"
      role="tab"
      :aria-selected="active === tab.code ? 'true' : 'false'"
      :class="{ active: active === tab.code }"
      @click="$emit('select', tab.code)"
    >
      {{ tab.name }}
      <span v-if="tab.count !== null && typeof tab.count !== 'undefined'">{{ tab.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LeadCommunicationTabs',
  props: {
    design: {
      type: String,
      required: true,
      validator: value => value === 'new'
    },
    tabs: {
      type: Array,
      required: true
    },
    active: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.lead-communication-tabs--new {
  display: flex;
  gap: $ui-space-8;
  padding: $ui-space-4;
  overflow-x: auto;
  scrollbar-color: $ui-blue $ui-surface;

  button {
    display: inline-flex;
    min-height: 46px;
    flex: 0 0 auto;
    align-items: center;
    gap: $ui-space-8;
    padding: 0 $ui-space-16;
    border: 1px solid $ui-line-strong;
    border-radius: $ui-tab-radius;
    background: $ui-surface;
    box-shadow: $ui-card-shadow;
    color: $ui-text;
    font-family: $ui-font-body;
    font-size: $ui-font-size-body;
    font-weight: 600;
    cursor: pointer;
    transition: border-color .15s ease, background-color .15s ease, transform .15s ease;

    &:hover {
      border-color: $ui-blue;
      transform: translateY(-1px);
    }

    &:focus-visible {
      outline: 3px solid rgba($ui-blue, .18);
      outline-offset: 2px;
    }

    &.active {
      border-color: $ui-blue;
      background: $ui-blue-soft;
      color: $ui-blue;
    }
  }

  span {
    display: inline-flex;
    min-width: 24px;
    min-height: 24px;
    align-items: center;
    justify-content: center;
    padding: 2px $ui-space-8;
    border-radius: $ui-control-radius;
    background: $ui-blue-soft;
    color: $ui-blue;
    font-family: $ui-font-heading;
    font-size: $ui-font-size-metadata;
    font-weight: 600;
  }
}
</style>
